module.exports = __webpack_public_path__ + "static/code-35ada2dde87e21d57a8e6b8c9affe071.png";